import { Environment } from './environment.types';
import { navigationList } from './navigation';

// base environment config
const environment: Environment = {
  apiBaseUrl: 'http://localhost:3000/api/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  navigation: navigationList,
  jiraAutoLogin: true,
  timeout: 15, // set timeout to 15 minutes
  // by default, show: Task Key, Internal Document ID, Version
  // hide: Rev
  fileConfig: {
    hideRev: true
  }
};

export default environment;
